import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function AlarmClock(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "AlarmClock", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "m35.79 43.657-2.565-4.44a.09.09 0 0 0-.12 0l-2.52 1.456a.081.081 0 0 0-.026.06.081.081 0 0 0 .026.06l2.565 4.44a1.537 1.537 0 0 0 2.1.517 1.545 1.545 0 0 0 .54-2.093Zm-18.375-3.014-2.52-1.456a.09.09 0 0 0-.12 0l-2.565 4.44a1.545 1.545 0 0 0 2.67 1.545l2.565-4.44a.082.082 0 0 0-.03-.09Zm-4.321-29.836a1.308 1.308 0 1 0-2.145 1.5l5.318 7.59 2.137-1.5-5.31-7.59ZM36.75 10.5a1.312 1.312 0 0 0-1.822.322l-5.333 7.568 2.138 1.5 5.317-7.59a1.305 1.305 0 0 0-.3-1.8Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.light,
        d: "M24 44.25c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.dark,
        d: "m36.277 20.648.982-1.395a3.75 3.75 0 0 0-.922-5.25l-2.715-1.898a3.75 3.75 0 0 0-5.25.923l-1.073 1.597a15 15 0 0 1 8.978 6.023Zm-16.68-7.598a3.75 3.75 0 0 0-5.25-.922l-2.685 1.897a3.749 3.749 0 0 0-.923 5.25l.983 1.395a15 15 0 0 1 9-6l-1.125-1.62Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.main,
        d: "M24 41.25c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M24 21a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm-9 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm9 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm9-9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.main,
        d: "M9.522 9.141A5.408 5.408 0 0 0 7.94 12.97a.676.676 0 1 0 1.353-.005 4.056 4.056 0 0 1 4.053-4.053.677.677 0 1 0 .005-1.353A5.407 5.407 0 0 0 9.522 9.14Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.main,
        d: "M13.35 4.854a8.111 8.111 0 0 0-8.126 8.126.676.676 0 1 0 1.353-.005 6.76 6.76 0 0 1 6.759-6.759.676.676 0 0 0 .678-.678.676.676 0 0 0-.664-.684Zm25.797 4.303a5.409 5.409 0 0 0-3.828-1.582.676.676 0 1 0 .004 1.352 4.056 4.056 0 0 1 4.053 4.054.675.675 0 0 0 .68.678.676.676 0 0 0 .673-.674 5.41 5.41 0 0 0-1.582-3.828Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.main,
        d: "M43.433 12.984a8.113 8.113 0 0 0-8.126-8.125.676.676 0 1 0 .005 1.352 6.76 6.76 0 0 1 6.759 6.759.678.678 0 0 0 .679.679.676.676 0 0 0 .683-.665Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M24 23.625a.75.75 0 0 0-.75.75v4.192l-2.033 2.026a.753.753 0 1 0 1.065 1.064l2.25-2.25a.75.75 0 0 0 .217-.532v-4.5a.75.75 0 0 0-.75-.75Z"
      }
    )
  ] });
}
AlarmClock.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "AlarmClock"
};
validateTidalLicense();
export {
  AlarmClock
};
//# sourceMappingURL=AlarmClock.js.map
